// 1. New array added by "New class subject button" is called newArr
// newArr can be found in line 469
// api passed on 146,
// change of fields 432,458,519

import React, { useState, useEffect } from "react";
import HeaderofAdash from "../subComponent/HeaderofAdash";
import SidebarOfAdash from "../subComponent/SidebarOfAdash";
import { Row, Col, Modal, Form } from "react-bootstrap";
import { AiOutlineConsoleSql, AiOutlinePlus } from "react-icons/ai";
import Dropdown2 from "../../subComponents/CustomSubComponents/Dropdown2";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import ReactPaginate from "react-paginate";
import { optionsSubject, roledrp } from "../../Helper";
import moment from "moment";

import { menumgmtApi } from "../../../utils/AdminDashApi/MenuMgmtApi";
import { subjectSubgroupApi } from "../../../utils/AdminDashApi/SubjectSubGroupApi";
import { subjectApi } from "../../../utils/AdminDashApi/SubjectApi";
import { fetchSubjectList } from "../../../utils/Api_Calls/api_calls_all";

const SubjectComp = () => {
  const [activefrom, setactivefrom] = useState("");
  const [activeto, setactiveTo] = useState("");
  const [activefrom2, setactivefrom2] = useState("");
  const [activeto2, setactiveTo2] = useState("");
  const [show, setShow] = useState(10);
  const [show2, setShow2] = useState("");

  const [subjectListResponse, setsubjectListResponse] = useState([]);

  const handleShow = () => setShow2(true);

  const [newArr, setNewArr] = useState([]);
  const [classresponse, setclassresponse] = useState([]);
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",
  };
  useEffect(() => {
    const fetchClassDropdown = async () => {
      try {
        const classresponse = await axios.get(
          "https://sass.britishstandardschool.com/api/Public/ClassList",
          {},
          headers
        );
        setclassresponse(classresponse.data);
        // console.log(classresponse);
      } catch (err) {
        if (err.classresponse) {
          console.error(err.classresponse.data);
          console.log(err.classresponse.status);
          console.log(err.classresponse.header);
        } else {
          console.error(`Error: ${err.message}`);
        }
      }
    };
    fetchClassDropdown();

    const fetchSubjectListFunc = async () => {
      try {
        const data = await fetchSubjectList();
        setsubjectListResponse(data);
        
      } catch (error) {
        // Handle error if needed
      }
    };

    fetchSubjectListFunc();
  }, []);
  const optionsShowt = [
    {
      id: 0,
      opt: "Select",
    },
    {
      id: 1,
      opt: 10,
    },
    {
      id: 2,
      opt: 20,
    },
    {
      id: 3,
      opt: 30,
    },
  ];
  const [mainpagesearch, setmainpagesearch] = useState("");
  const handlemainpagesearch = (e) => {
    setmainpagesearch(e.target.value);
  };

 

  const [classdrp, setClassdrp] = useState("");
  const [subject, setSubject] = useState("");
  const drpfuncSubject = (myval, myid) => {
    setSubject(myid);
  };
  const drpfuncClass = (myval, myid) => {
    setClassdrp(myid);
  };

  const [show3, setShow3] = useState(false);

  const handleClose2 = () => {
    setShow3(false);
  };
  const [modalitem, setmodalitem] = useState(null);
  const [editId,seteditId] = useState("")
  const handleShow3 = (myitem) => {
    setShow3(true);
    seteditId(myitem.subjectId)
    setsubnamemod2(myitem.subjectName)
    setshortnamemod2(myitem.shortName)
    setactivefromModal2(myitem.effectiveFrom)
    setactiveToModal2(myitem.effectiveTo)
    setmajormod2(myitem.Major)

  };
  async function DeleteSubjectById(myid) {
    //https://localhost:7229/api/Admin/DeleteCampusById?myid=5
    try {
      axios
        .delete(
          `https://localhost:7229/api/Admin/DeleteSubjectById?myid=${myid}`,
          
          headers
        )
        .then(function (response) {
          setsubjectListResponse(response.data);
        });
    } catch (err) {
      if (err.response) {
        console.error(err.response.data);
        console.log(err.response.status);
        console.log(err.response.header);
      } else {
        console.error(`Error: ${err.message}`);
      }
    }
  }
  const handleDelete= async(myitem)=>{
    await DeleteSubjectById(myitem.subjectId)
  }
  const handleClosemenumodal = () => {
    setShow3(false);
  };
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [paginatenumselected, setpaginatenumselected] = useState(0);
  const [paginatenumselectedfiltered, setpaginatenumselectedfiltered] =
    useState(0);
  const [pageCount2, setPageCount2] = useState(0);
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2, setitemsPerPage2] = useState(10);

  const [itemsPerPagefiltered, setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2, setpaginatenumselected2] = useState(0);
  const [filteredArr, setfilteredArr] = useState(
    subjectListResponse ? subjectListResponse : subjectApi.data
  );

  useEffect(() => {
    setfilteredArr(subjectListResponse);
  }, [subjectListResponse]);

 

  const [tempfilteredarr, settempfilteredarr] = useState([]);
  useEffect(() => {
    const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
    const tempArr = filteredArr?.slice(itemOffsetfiltered, endOffsetfiltered);
    settempfilteredarr(tempArr);
    setPageCountfiltered(Math.ceil(filteredArr?.length / itemsPerPagefiltered));
    setitemsPerPagefiltered(show ? show : 10);
    //flag2
  }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr, show]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % subjectListResponse.length;
    setpaginatenumselected(event.selected);
    setItemOffset(newOffset);
  };
  const handlePageClickfiltered = (event) => {
    const newOffsetf =
      (event.selected * itemsPerPagefiltered) % subjectListResponse?.length ;
    setpaginatenumselectedfiltered(event.selected);
    setItemOffsetfiltered(newOffsetf);
  };
 

  const handleClose = () => {
    setShow2(false);
  };

  async function SaveOrUpdateSubjectInfo(data) {
    console.log(data);
    try {
      axios
        .post(
          "https://localhost:7229/api/Admin/SaveOrUpdateSubject",
          data,
          headers
        )
        .then(function (response) {
          setsubjectListResponse(response.data);
        });
    } catch (err) {
      if (err.response) {
        console.error(err.response.data);
        console.log(err.response.status);
        console.log(err.response.header);
      } else {
        console.error(`Error: ${err.message}`);
      }
    }
  }

  const [subjectnamemodalvalue, setsubjectnamemodalvalue] = useState("");
  const [classnamemodalvalue, setclassnamemodalvalue] = useState("");

  const [subjectnamemodalvalue2, setsubjectnamemodalvalue2] = useState("");
  const [classnamemodalvalue2, setclassnamemodalvalue2] = useState("");
  const [rolemodalvalue2, setrolemodalvalue2] = useState("");
  const drpfuncclassnamemodal = (mystatus, myid) => {
    setclassnamemodalvalue(myid);
  };
  const drpfuncclassnamemodal2 = (mystatus, myid) => {
    setclassnamemodalvalue2(myid);
  };

  const drpfuncsubjectnamemodal = (mystatus, myid) => {
    setsubjectnamemodalvalue(myid);
  };
  const drpfuncsubjectnamemodal2 = (mystatus, myid) => {
    setsubjectnamemodalvalue2(myid);
  };
  const drpfuncrolemodal2 = (mystatus, myid) => {
    setrolemodalvalue2(mystatus);
    console.log("manualselect", mystatus);
  };

  const handlesearch = () => {
    setactivefrom("");
  };

  const [searchinputmodal, setsearchinputmodal] = useState("");
  const [rolesearchkey, setrolesearchkey] = useState("");
  const handlesearchinputmodal = (e) => {
    setsearchinputmodal(e.target.value);
  };
  const handlesearchmodal = () => {
    setrolesearchkey(searchinputmodal);
  };
  const drpfuncshow = (myshow, id) => {
    setShow(myshow);
  };

  const [ischkmodal, setischkmodal] = useState(false);
  const handleChangechk = (event) => {
    if (event.target.checked) {
      console.log("✅ Checkbox is checked");
    } else {
      console.log("⛔️ Checkbox is NOT checked");
    }
    setischkmodal((current) => !current);
  };
  const handleModaleditsave = () => {
    console.log(rolemodalvalue2);
    setShow3(false);
  };

  const handleActiveFrom = (activefromval) => {
    if (activefromval != null) {
      var dtmnt = activefromval.$M + 1;
      var dtfinalc = activefromval.$y + "-" + dtmnt + "-" + activefromval.$D;

      var tt = moment(dtfinalc, "YYYY-MM-DD").calendar();
      console.log(tt - moment("2023-06-12", "YYYY-MM-DD").calendar());
      console.log(dtfinalc);
      setactivefrom(dtfinalc);
    }
  };
  const [activefromModal1, setactivefromModal1] = useState("");
  const handleActiveFromModal1 = (activefromval) => {
    if (activefromval != null) {
      var dtmnt = activefromval.$M + 1;
      var dtfinalc = activefromval.$y + "-" + dtmnt + "-" + activefromval.$D;

      var tt = moment(dtfinalc, "YYYY-MM-DD").calendar();
      
      console.log(dtfinalc);
      setactivefromModal1(moment(dtfinalc).format("YYYY-MM-DD"));
    }
  };
  const handleActiveTo = (activetoval) => {
    if (activetoval != null) {
      var dtmnt = activetoval.$M + 1;
      var dtfinalc = activetoval.$y + "-" + dtmnt + "-" + activetoval.$D;
      var dd =
        moment(activeto, "YYYY-MM-DD").calendar() -
        moment(dtfinalc, "YYYY-MM-DD").calendar();
      setactiveTo(dtfinalc);
    }
  };
  const [activeToModal1, setactiveToModal1] = useState("");
  const handleActiveToModal1 = (activetoval) => {
    if (activetoval != null) {
      var dtmnt = activetoval.$M + 1;
      var dtfinalc = activetoval.$y + "-" + dtmnt + "-" + activetoval.$D;
      var dd =
        moment(activeto, "YYYY-MM-DD").calendar() -
        moment(dtfinalc, "YYYY-MM-DD").calendar();
      setactiveToModal1(moment(dtfinalc).format("YYYY-MM-DD"));
    }
  };
  // Modal2activefromto

  const handleActiveFrom2 = (activefromval) => {
    if (activefromval != null) {
      var dtmnt = activefromval.$M + 1;
      var dtfinalc = activefromval.$y + "-" + dtmnt + "-" + activefromval.$D;

      var tt = moment(dtfinalc, "YYYY-MM-DD").calendar();
      console.log(tt - moment("2023-06-12", "YYYY-MM-DD").calendar());
      console.log(dtfinalc);
      setactivefrom2(dtfinalc);
    }
  };
  const [activefromModal2, setactivefromModal2] = useState("");
  const handleActiveFromModal2 = (activefromval) => {
    if (activefromval != null) {
      var dtmnt = activefromval.$M + 1;
      var dtfinalc = activefromval.$y + "-" + dtmnt + "-" + activefromval.$D;

      var tt = moment(dtfinalc, "YYYY-MM-DD").calendar();
      console.log(tt - moment("2023-06-12", "YYYY-MM-DD").calendar());
      console.log(dtfinalc);
      setactivefromModal2(moment(dtfinalc).format("YYYY-MM-DD"));
    }
  };
  const handleActiveTo2 = (activetoval) => {
    if (activetoval != null) {
      var dtmnt = activetoval.$M + 1;
      var dtfinalc = activetoval.$y + "-" + dtmnt + "-" + activetoval.$D;
      var dd =
        moment(activeto, "YYYY-MM-DD").calendar() -
        moment(dtfinalc, "YYYY-MM-DD").calendar();
      setactiveTo2(moment(dtfinalc).format("YYYY-MM-DD"));
    }
  };
  const [activeToModal2, setactiveToModal2] = useState("");
  const handleActiveToModal2 = (activetoval) => {
    if (activetoval != null) {
      var dtmnt = activetoval.$M + 1;
      var dtfinalc = activetoval.$y + "-" + dtmnt + "-" + activetoval.$D;
      var dd =
        moment(activeto, "YYYY-MM-DD").calendar() -
        moment(dtfinalc, "YYYY-MM-DD").calendar();
      setactiveToModal2(moment(dtfinalc).format("YYYY-MM-DD"));
    }
  };
  const [bestCountmod2, setbestCountmod2] = useState("");
  const handleBestCountmod2 = (e) => {
    setbestCountmod2(e.target.value);
  };

  const [bestCountmod1, setbestCountmod1] = useState("");
  const handleBestCountmod1 = (e) => {
    setbestCountmod1(e.target.value);
  };

  const [subgroupdesMod2, setsubgroupdesMod2] = useState("");
  const handlesubgroupdesMod2 = (e) => {
    setsubgroupdesMod2(e.target.value);
  };

  const [subgroupdesMod1, setsubgroupdesMod1] = useState("");
  const handlesubgroupdesMod1 = (e) => {
    setsubgroupdesMod1(e.target.value);
  };

  const [subgroupdesMod2label, setsubgroupdesMod2label] = useState("");
  const [subgroupdesMod1label, setsubgroupdesMod1label] = useState("");
  const [fclassnamemodalvaluelabel, setfclassnamemodalvaluelabel] =
    useState("");

  const [resultSerialModal1label, setresultSerialModal1label] = useState("");
  const [activefromModal1label, setactivefromModal1label] = useState("");
  const [activetoModal1label, setactivetoModal1label] = useState("");
  const [activefromModal2label, setactivefromModal2label] = useState("");
  const [activetoModal2label, setactivetoModal2label] = useState("");

  const [fclassnamemodalvaluelabel2, setfclassnamemodalvaluelabel2] =
    useState("");
  const [fsubnamemodalvaluelabel2, setfsubnamemodalvaluelabel2] = useState("");
  const [bestcountlabelmod2, setbestcountlabelmod2] = useState("");
  const [bestcountlabelmod1, setbestcountlabelmod1] = useState("");
  const [activefromModal1label2, setactivefromModal1label2] = useState("");
  const [activetoModal1label2, setactivetoModal1label2] = useState("");

  const [subnamemod1, setsubnamemod1] = useState("");
  const [subnamemod2, setsubnamemod2] = useState("");

  const [shortnamemod1, setshortnamemod1] = useState("");
  const [majormod1, setmajormod1] = useState("");
  const [shortnamemod2, setshortnamemod2] = useState("");
  const [majormod2, setmajormod2] = useState("");

  const [labelshortnamemod1, setlabelshortnamemod1] = useState("");
  const [labelsubnamemod1, setlabelsubnamemod1] = useState("");
  const [labelmajormod1, setlabelmajormod1] = useState("");
  const [labelshortnamemod2, setlabelshortnamemod2] = useState("");
  const [labelsubnamemod2, setlabelsubnamemod2] = useState("");
  const [labelmajormod2, setlabelmajormod2] = useState("");

  const [bordersubnamemod1, setbordersubnamemod1] = useState(false);
  const [bordershortnamemod1, setbordershortnamemod1] = useState(false);
  const [bordermajormod1, setbordermajormod1] = useState(false);
  const [borderactivefrommod1, setborderactivefrommod1] = useState("");
  const [borderactivetomod1, setborderactivetomod1] = useState("");

  const [bordersubnamemod2, setbordersubnamemod2] = useState(false);
  const [bordershortnamemod2, setbordershortnamemod2] = useState(false);
  const [bordermajormod2, setbordermajormod2] = useState(false);
  const [borderactivefrommod2, setborderactivefrommod2] = useState("");
  const [borderactivetomod2, setborderactivetomod2] = useState("");

  const handlesubnameMod1 = (e) => {
    setsubnamemod1(e.target.value);
  };



  const handlesaveModal1 = async () => {
  
    if (!subnamemod1 && subnamemod1 == "") {
      setlabelsubnamemod1("Sub name required");
      setbordersubnamemod1(true);
    } else {
      setlabelsubnamemod1("");
      setbordersubnamemod1(false);
    }
    if (!shortnamemod1 && shortnamemod1 == "") {
      setlabelshortnamemod1("Short Name required");
      setbordershortnamemod1(true);
    } else {
      setlabelshortnamemod1("");
      setbordershortnamemod1(false);
    }

    if( subnamemod1 && shortnamemod1
      ){
        console.log("inside the validation")
        const finalArr = {
          "SubjectId":0,
          "SubjectName": subnamemod1,
          "ShortName": shortnamemod1,
          "Major" : majormod1? true:false,
          "EffectiveFrom": activefromModal1,
          "EffectiveTo": activeToModal1
        }

        await SaveOrUpdateSubjectInfo(finalArr)
        setShow2(false)
      }
      else{
        console.log("outside validation")
      }
  };

  useEffect(() => {
    console.log(newArr);
  }, [newArr]);
  // Modal 2

  const handlesaveModal2 = async () => {
   
    if (!subnamemod2 && subnamemod2 == "") {
      setlabelsubnamemod2("Sub name required");
      setbordersubnamemod2(true);
    } else {
      setlabelsubnamemod2("");
      setbordersubnamemod2(false);
    }
    if (!shortnamemod2 && shortnamemod2 == "") {
      setlabelshortnamemod2("Short Name required");
      setbordershortnamemod2(true);
    } else {
      setlabelshortnamemod2("");
      setbordershortnamemod2(false);
    }
   
    if(subnamemod2 && shortnamemod2){
      console.log("inside the validation of modal 2",editId)
      const finalArr = {
        "SubjectId":editId,
        "SubjectName": subnamemod2,
        "ShortName": shortnamemod2,
        "Major" : majormod2? true:false,
        "EffectiveFrom": activefromModal2,
        "EffectiveTo": activeToModal2
      }

      await SaveOrUpdateSubjectInfo(finalArr)
      setShow3(false)
    }
    else{
      console.log("outside validation")
    }
  };

  const handleClose3 = () => {
    setShow3(false);
  };
  // start
  return (
    <div className="d-flex flexvaluecomp">
      <SidebarOfAdash />
      <div className="contentpartwidthwrapper">
        <HeaderofAdash head="Subject" />
        <div className="contentofadmindash contentflexvalue">
          <Row>
            <Col lg={10} className="m-auto">
              <Row>
                <Col lg={3}>
                  <div className="basicinput">
                    <p></p>
                    <button className="cmbutton" onClick={handleShow}>
                      {" "}
                      <AiOutlinePlus /> New Subject
                    </button>
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="basicinput">
                    <p>Subject Name</p>
                    <div className="dropdownwrapper">
                      <Dropdown2
                        func={drpfuncSubject}
                        myplaceholder="Select Subject"
                        fontsize="16"
                        fontfamily="'Poppins', sans-serif"
                        options={optionsSubject}
                      />
                    </div>
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="basicinput">
                    <p>Active from</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={activefrom}
                        onChange={(newvaldob) => handleActiveFrom(newvaldob)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{
                              ...params.inputProps,
                              placeholder: "Active From",
                            }}
                            error={false}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="basicinput">
                    <p>Active To</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={activeto}
                        onChange={(newvaldob) => handleActiveTo(newvaldob)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{
                              ...params.inputProps,
                              placeholder: "Active To",
                            }}
                            error={false}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col className="m-auto" lg={4}>
              <Row>
                <Col lg={3}>
                  <div className="basicinput">
                    <p>Show</p>
                    <div className="dropdownwrapper">
                      <Dropdown2
                        func={drpfuncshow}
                        myplaceholder="Select"
                        fontsize="16"
                        fontfamily="'Poppins', sans-serif"
                        options={optionsShowt}
                      />
                    </div>
                  </div>
                </Col>
                <Col lg={9}>
                  <div className="basicinput">
                    <p>Search</p>
                    <div className="wrap">
                      <input
                        type="text"
                        placeholder="Search"
                        value={mainpagesearch}
                        onChange={handlemainpagesearch}
                      />
                      <img
                        src="./assets/images/dashboards/adminDashboard/flexvalue/search.png"
                        alt=""
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col lg={12} className="m-auto">
              <div className="flexvaluetable">
                <table>
                  <thead>
                    <tr>
                      {subjectApi.heading.map((item, key) => {
                        return (
                          <th key={key}>
                            {" "}
                            <div>{item.head}</div>{" "}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  {
                    // mainpagesearch==""?
                    <tbody>
                      {
                        tempfilteredarr
                          ? tempfilteredarr.map((item, key) => {
                              return (
                                <tr key={key}>
                                  <td>{item.subjectId}</td>
                                  <td>{item.subjectName}</td>
                                  <td>{item.shortName}</td>
                                  <td>{item.effectiveFrom}</td>
                                  <td>{item.effectiveTo}</td>
                                  <td>
                                    <div className="img text-center">
                                      <img
                                        onClick={() => handleShow3(item)}
                                        src="./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
                                        alt=""
                                      />
                                      <img style={{width:"22px",marginLeft:"10px"}} onClick={()=>handleDelete(item)} src="./assets/images/dashboards/adminDashboard/icon/deleteIcon.png" alt="" />
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          : ""
                      }
                    </tbody>
                  }
                </table>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={10} className="m-auto">
              {tempfilteredarr ? (
                <Row>
                  <Col lg={6}>
                    <p className="pagileft">
                      Showing {itemOffsetfiltered + 1} to{" "}
                      {itemOffsetfiltered + 10} of {subjectListResponse.length}{" "}
                      entries 
                    </p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName="pagination"
                      pageLinkClassName="page-num"
                      previousLinkClassName="page-numl"
                      nextLinkClassName="page-numr"
                      activeLinkClassName="activelink"
                      disabledClassName="disabledClass"
                    />
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col lg={6}>
                    <p className="pagileft">
                      Showing {itemOffset + 1} to {itemOffset + 10} of{" "}
                      {subjectApi.data.length} entries (filtered from 10 total
                      entries)
                    </p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName="pagination"
                      pageLinkClassName="page-num"
                      previousLinkClassName="page-numl"
                      nextLinkClassName="page-numr"
                      activeLinkClassName="activelink"
                      disabledClassName="disabledClass"
                    />
                  </Col>
                </Row>
              )}
            </Col>
          </Row>

          {/* modal1ori */}

          <Modal
            dialogClassName="mymodalclsSubjectAdmin"
            show={show2}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title className="ms-auto">Class Subject</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={10} className="m-auto">
                  <Row>
                    <Col lg={4} className="pr7">
                      <div className="basicinput">
                        <p>Subject Name</p>
                        <div className="inputgap h35">
                          <input
                            type="text"
                            style={
                              bordersubnamemod1
                                ? { borderColor: "rgb(237, 28, 36)" }
                                : { borderColor: "#ebebeb" }
                            }
                            value={subnamemod1}
                            onChange={(e) => setsubnamemod1(e.target.value)}
                          />

                          <label>{labelsubnamemod1}</label>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4} className="pr7 pl7">
                      <div className="basicinput modalinputgap">
                        <p>Short Name</p>
                        <div className="inputgap">
                          <div className="dropdownwrapper">
                            <input
                              type="text"
                              style={
                                bordershortnamemod1
                                  ? { borderColor: "rgb(237, 28, 36)" }
                                  : { borderColor: "#ebebeb" }
                              }
                              value={shortnamemod1}
                              onChange={(e) => setshortnamemod1(e.target.value)}
                            />
                          </div>
                          <label>{labelshortnamemod1}</label>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4} className="pr7 pl7">
                      <div className="basicinput modalinputgap">
                        <p>Major</p>
                        <div className="inputgap">
                          <div className="dropdownwrapper">
                            <input
                              type="text"
                              style={
                                bordermajormod1
                                  ? { borderColor: "rgb(237, 28, 36)" }
                                  : { borderColor: "#ebebeb" }
                              }
                              value={majormod1}
                              onChange={(e) => setmajormod1(e.target.value)}
                            />
                          </div>
                          <label>{labelmajormod1}</label>
                        </div>
                      </div>
                    </Col>

                    <Col lg={6}>
                      <div className="basicinput modalinputgap">
                        <p>Effective from</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap">
                            <DatePicker
                              value={activefromModal1}
                              onChange={(newvaldob) =>
                                handleActiveFromModal1(newvaldob)
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  style={
                                    borderactivefrommod1 == "err"
                                      ? {
                                          border: "1px solid #ED1C24",
                                          borderRadius: "10px",
                                        }
                                      : {}
                                  }
                                  inputProps={{
                                    ...params.inputProps,
                                    placeholder: "Effective From",
                                  }}
                                  error={false}
                                />
                              )}
                            />
                            <label>{activefromModal1label}</label>
                          </div>
                        </LocalizationProvider>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="basicinput">
                        <p>Effective To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap">
                            <DatePicker
                              value={activeToModal1}
                              onChange={(newvaldob) =>
                                handleActiveToModal1(newvaldob)
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  style={
                                    borderactivetomod1 == "err"
                                      ? {
                                          border: "1px solid #ED1C24",
                                          borderRadius: "10px",
                                        }
                                      : {}
                                  }
                                  inputProps={{
                                    ...params.inputProps,
                                    placeholder: "Effective To",
                                  }}
                                  error={false}
                                />
                              )}
                            />
                            <label>{activetoModal1label}</label>
                          </div>
                        </LocalizationProvider>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="m-auto" style={{ borderTop: "0" }}>
              <button variant="secondary" type="button" onClick={handleClose}>
                Close
              </button>
              <button variant="primary" onClick={handlesaveModal1}>
                Save
              </button>
            </Modal.Footer>
          </Modal>

          {/* modal2ori */}
          <Modal
            dialogClassName="mymodalmenueid"
            show={show3}
            onHide={handleClose2}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title className="ms-auto">Class Subject</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={10} className="m-auto">
                  <Row>
                    <Col lg={10} className="m-auto">
                      <Row>
                        <Col lg={4} className="pr7">
                          <div className="basicinput">
                            <p>Subject Name</p>
                            <div className="inputgap h35">
                              <input
                                type="text"
                                style={
                                  bordersubnamemod2
                                    ? { borderColor: "rgb(237, 28, 36)" }
                                    : { borderColor: "#ebebeb" }
                                }
                                value={subnamemod2}
                                onChange={(e) => setsubnamemod2(e.target.value)}
                              />

                              <label>{labelsubnamemod2}</label>
                            </div>
                          </div>
                        </Col>
                        <Col lg={4} className="pr7 pl7">
                          <div className="basicinput modalinputgap">
                            <p>Short Name</p>
                            <div className="inputgap">
                              <div className="dropdownwrapper">
                                <input
                                  type="text"
                                  style={
                                    bordershortnamemod2
                                      ? { borderColor: "rgb(237, 28, 36)" }
                                      : { borderColor: "#ebebeb" }
                                  }
                                  value={shortnamemod2}
                                  onChange={(e) =>
                                    setshortnamemod2(e.target.value)
                                  }
                                />
                              </div>
                              <label>{labelshortnamemod2}</label>
                            </div>
                          </div>
                        </Col>
                        <Col lg={4} className="pr7 pl7">
                          <div className="basicinput modalinputgap">
                            <p>Major</p>
                            <div className="inputgap">
                              <div className="dropdownwrapper">
                                <input
                                  type="text"
                                  style={
                                    bordermajormod2
                                      ? { borderColor: "rgb(237, 28, 36)" }
                                      : { borderColor: "#ebebeb" }
                                  }
                                  value={majormod2}
                                  onChange={(e) => setmajormod2(e.target.value)}
                                />
                              </div>
                              <label>{labelmajormod2}</label>
                            </div>
                          </div>
                        </Col>

                        <Col lg={6}>
                          <div className="basicinput modalinputgap">
                            <p>Effective from</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <div className="inputgap">
                                <DatePicker
                                  value={activefromModal2}
                                  onChange={(newvaldob) =>
                                    handleActiveFromModal2(newvaldob)
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      style={
                                        borderactivefrommod2 == "err"
                                          ? {
                                              border: "1px solid #ED1C24",
                                              borderRadius: "10px",
                                            }
                                          : {}
                                      }
                                      inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Effective From",
                                      }}
                                      error={false}
                                    />
                                  )}
                                />
                                <label>{activefromModal2label}</label>
                              </div>
                            </LocalizationProvider>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="basicinput">
                            <p>Effective To</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <div className="inputgap">
                                <DatePicker
                                  value={activeToModal2}
                                  onChange={(newvaldob) =>
                                    handleActiveToModal2(newvaldob)
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      style={
                                        borderactivetomod2 == "err"
                                          ? {
                                              border: "1px solid #ED1C24",
                                              borderRadius: "10px",
                                            }
                                          : {}
                                      }
                                      inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Effective To",
                                      }}
                                      error={false}
                                    />
                                  )}
                                />
                                <label>{activetoModal2label}</label>
                              </div>
                            </LocalizationProvider>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="m-auto" style={{ borderTop: "0" }}>
              <button variant="secondary" type="button" onClick={handleClose3}>
                Close
              </button>
              <button variant="primary" onClick={handlesaveModal2}>
                Update
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default SubjectComp;
